import React from 'react';

import { CallToActionProps } from '../utils/Types';

import styles from './ActionMenu.module.scss';

const ActionMenu = (props: CallToActionProps): JSX.Element => {
  return (
    <div className={styles.headerActionMenu}>
      <div className={styles.headerActionMenuLightButton} onClick={() => props.learnOnClick()}>
        LEARN MORE
      </div>
      <div className={styles.headerActionMenuLightButton} onClick={() => props.shareOnClick()}>
        SHARE
      </div>
      <div className={styles.headerActionMenuButton} onClick={() => props.contactOnClick()}>
        &#8594; CONTACT
      </div>
    </div>
  );
};

export default ActionMenu;
